import { render } from "./SearchBar.vue?vue&type=template&id=62a42268&scoped=true&ts=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=62a42268&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a42268"]])

export default __exports__